module.exports = __webpack_public_path__ + "static/media/logo_locci.751be5bf.svg";